// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_3G7cc clearfix","comment":"index_comment_0Blik","pic":"index_pic_dtQdN","v_logo":"index_v_logo_bWaTm","text":"index_text_RbFXR","time":"index_time_R-cn6"};